module.exports = __webpack_public_path__ + "static/media/02.905363aa.png";